import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import PageWrapper from "components/Global/PageOrganization/PageWrapper";

import { getLoanProceedsRunTable, saveLoanProceedsRunTable } from "../CashOutProceeds/LoanProceedsSettings/LoanProceedsSettings.store";

import { Header, RunTable, UpdateCalculationsButton } from "./";
import "./styles.css";

const LoanProceedsRunTable = ({ getLoanProceedsRunTable, loanProceeds, saveLoanProceedsRunTable }) => {
  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    getLoanProceedsRunTable();
  }, []);

  useEffect(() => {
    const initialItems = loanProceeds.runList.map(item => `${item.propertyTypeId}#${item.loanTypeId}`);
    setCheckedItems(initialItems);
  }, [loanProceeds]);

  const onCheck = (propertyType, loanType) => {
    const newItems = Array.from(checkedItems);
    const newId = `${`${propertyType.propertyType}#${loanType.loanType}`}`;
    if (checkedItems.includes(newId)) {
      newItems.splice(checkedItems.indexOf(newId), 1);
    } else {
      newItems.push(`${`${propertyType.propertyType}#${loanType.loanType}`}`);
    }
    setCheckedItems(newItems);
  };

  const updateRunTable = () => saveLoanProceedsRunTable({ checkedItems });

  return (
    <div className="loan-proceeds-run-table-wrapper">
      <PageWrapper>
        <Grid container direction="column" style={{ maxWidth: "1300px" }}>
          <Grid item><Header /></Grid>
          <Grid item container justify="flex-end"><UpdateCalculationsButton onSubmit={updateRunTable} /></Grid>
          <Grid item container justify="center"><RunTable checkedItems={checkedItems} onCheck={onCheck} /></Grid>
        </Grid>
      </PageWrapper>
    </div>
  );
};

const mapStateToProps = ({ loanProceedsReducer: loanProceeds }) => ({ loanProceeds });

export default compose(connect(mapStateToProps, { getLoanProceedsRunTable, saveLoanProceedsRunTable }))(LoanProceedsRunTable);
